module.exports = __webpack_public_path__ + "static/media/Innovative-Friend.ce34e432.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/Innovative-Friend.gif
// module id = 321
// module chunks = 0